import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { addDays, startOfMonth, endOfMonth, subMonths, addMonths, subDays } from 'date-fns';

enum SwitchDatesRange {
  Month = 1,
  Week = 2,
  Day = 3,
}

@Component({
  selector: 'app-vehicle-details-routes-calendar',
  templateUrl: './vehicle-details-routes-calendar.component.html',
  styleUrls: ['./vehicle-details-routes-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleDetailsRoutesCalendarComponent implements OnDestroy {

  @Output() private onHideCalendar: EventEmitter<void> = new EventEmitter();
  @Output() private onSubmitCalendar: EventEmitter<Date[]> = new EventEmitter();

  @Input() public isVisible: boolean;

  public rangeDate: Date[];

  public maxDateValue = new Date();

  public readonly switchDatesRange = [
    { type: SwitchDatesRange.Month, title: this.translate.instant('month') },
    { type: SwitchDatesRange.Week, title: this.translate.instant('week') },
    { type: SwitchDatesRange.Day, title: this.translate.instant('oneDay') },
  ];

  constructor(
    private translate: TranslateService,
  ) { }

  ngOnDestroy(): void {
    
  }

  public submit(): void {
    if (!this.rangeDate.length) {
      alert(this.translate.instant('selectADateToShowRoutes'));
      return;
    }
    this.emitData();
  }

  public emitData(): void {
    this.onHide();
    const [from, to] = this.rangeDate;
    this.onSubmitCalendar.emit([from, to ? to : from]);
    this.resetSelectedDate();
  }

  public onHide(): void {
    this.onHideCalendar.emit();
  }

  public resetSelectedDate(): void {
    this.rangeDate = [];
    this.maxDateValue = new Date();
  }

  public onSelectDate(): void {
    const [from] = this.rangeDate;
    const maxDate = addDays(from, 31);
    if (maxDate >= new Date()) {
      this.maxDateValue = new Date();
      return;
    }
    this.maxDateValue = maxDate;
  }

  public onClickSwitchDateValue(type: SwitchDatesRange, isLeft?: boolean): void {
    if (type === SwitchDatesRange.Month) {
      this.setMonthRange(isLeft);
      return;
    }
    if (type === SwitchDatesRange.Week) {
      this.setWeekRange(isLeft);
      return;
    }
    if (type === SwitchDatesRange.Day) {
      this.setDayRange(isLeft);
      return;
    }
  }

  private setMonthRange(isLeft?: boolean): void {
    const [from] = this.rangeDate || [];
    const date = from ? (isLeft ? subMonths(from, 1) : addMonths(from, 1)) : new Date();

    const startMonth = startOfMonth(date > this.maxDateValue ? new Date() : date);
    const endMonth = endOfMonth(date);
    const validEndMonth = endMonth > this.maxDateValue ? new Date() : endMonth;

    this.rangeDate = [startMonth, validEndMonth];
  }

  private setWeekRange(isLeft?: boolean): void {
    const [from, to] = this.rangeDate || [];
    const WEEK = 7;

    if ((from === to || (from && !to)) && !isLeft) {
      this.rangeDate = [from, addDays(from, WEEK)];
      return;
    }

    const ifEndDayIsBiggerOrEqualMaxDate = !isLeft && to && to >= this.maxDateValue;
    const startDay = from ? (isLeft || ifEndDayIsBiggerOrEqualMaxDate ? subDays((ifEndDayIsBiggerOrEqualMaxDate ? new Date() : from), WEEK) : addDays(from, WEEK)) : subDays(new Date(), WEEK);
    const endDay = addDays(startDay, WEEK);
    const validEndDay = endDay > this.maxDateValue ? new Date() : endDay;

    this.rangeDate = [startDay, validEndDay];
  }

  private setDayRange(isLeft?: boolean): void {
    const [from, to] = this.rangeDate || [];
    const DAY = 1;

    const ifEndDayIsBiggerOrEqualMaxDate = (!this.rangeDate) || !isLeft && to && to >= this.maxDateValue;
    if (ifEndDayIsBiggerOrEqualMaxDate) {
      this.rangeDate = [new Date(), new Date()];
      return;
    }

    const startDay = from ? (isLeft ? subDays(from, DAY) : addDays(from, DAY)) : subDays(new Date(), DAY);
    this.rangeDate = [startDay, startDay];
  }

}

